import { useSelector } from "react-redux";
import { useSignalRNotifications } from "./useSignalRNotifications";

import { useDispatch } from "react-redux";

import { endpoints } from "config";
import { setUIUpdate } from "reducers/notificationReducer";
import { loadTokenResource } from "helpers/auth";

export const useHandleSignalRNotifications = () => {
  const resource = loadTokenResource();

  const accessToken = resource?.accessToken;

  const dispatch = useDispatch();
  useSignalRNotifications<any>({
    url: endpoints.signalR,
    token: accessToken ?? "",
    additionalMessageHandlers: [
      {
        messageCode: "ApplicationDataPush",
        handler: notification => {
          dispatch(setUIUpdate(notification));
        },
      },
      {
        messageCode: "SessionDataPush",
        handler: notification => {
          dispatch(setUIUpdate(notification));
        },
      },
    ],
    activate: !!accessToken,
  });
};
